import apiService from "./api";

// Finansije restorana - 4 ekrana (Zarada, Obračuni, Transakcije, Ugovor i
// cijene), vidi docs/2026/10/14_10_2026_Backend_specifikacija_finansije_4_ekrana.md.
// Ranije: 12 data-tabova. Migrirano sa GPS/dostavljackog backend-a
// (bivši src/plugins/gpsApi.js, uklonjen) na glavni restoran API - vidi
// ticket #223672 i "FINALNI zadatak ... v2" (04.09.2026).
//
// "Isplate" i "Isplate restoranu" su POTVRĐENO isti endpoint (/payouts), kao
// i "Plaćanja platformi" i "Uplate restorana" (/platform-payments) - zato
// postoji samo jedan set metoda za svaki par, i po jedan tab u finance.vue.
//
// POST rute su ograničene na admin korisnike (restoran dobija 403), OSIM
// POST /refunds koji restoran korisnik smije sam da pokrene (zahtjev ostaje
// "pending" dok admin ne odobri PATCH .../approve - tek tad se knjiži).
const restaurantFinanceService = {
  getFinancialOverview(restaurantId, params) {
    return apiService.get(`/restaurants/${restaurantId}/financial-overview`, params);
  },
  // Redovi iz kojih je nastao jedan broj razrade (category = income_vs_costs[].key).
  getStatementLines(restaurantId, params) {
    return apiService.get(`/restaurants/${restaurantId}/statement/lines`, params);
  },
  // Kupac, vrijednost i max_refund za modal "Zatraži refundaciju".
  getOrderSummary(orderId) {
    return apiService.get(`/orders/${orderId}/summary`);
  },
  getTransactions(restaurantId, params) {
    return apiService.get(`/restaurants/${restaurantId}/transactions`, params);
  },
  // Lista usluga za Transakcije filter (service_id). Ticket #223693 - tačan
  // oblik odgovora još nije potvrđen; komponenta sakriva filter ako je prazan.
  getServiceTypes() {
    return apiService.get(`/service-types`);
  },
  getBalanceLedger(restaurantId, params) {
    return apiService.get(`/restaurants/${restaurantId}/balance-ledger`, params);
  },
  getPayouts(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/payouts`);
  },
  createPayout(restaurantId, data) {
    return apiService.post(`/restaurants/${restaurantId}/payouts`, data);
  },
  getPlatformPayments(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/platform-payments`);
  },
  createPlatformPayment(restaurantId, data) {
    return apiService.post(`/restaurants/${restaurantId}/platform-payments`, data);
  },
  getPromotions(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/promotions`);
  },
  createPromotion(restaurantId, data) {
    return apiService.post(`/restaurants/${restaurantId}/promotions`, data);
  },
  getRefunds(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/refunds`);
  },
  createRefund(restaurantId, data) {
    return apiService.post(`/restaurants/${restaurantId}/refunds`, data);
  },
  approveRefund(restaurantId, refundId) {
    return apiService.patch(`/restaurants/${restaurantId}/refunds/${refundId}/approve`);
  },
};

export default restaurantFinanceService;
